<template>
  <md-card>
    <md-card-content>
      <div class="md-layout">
        <room-type-select
          required
          multiple
          class="md-layout-item md-size-45"
          style="margin-right: 10%"
          v-model="filters.room_type_ids"
          :disabled="filters.board_ids.length > 0"
        ></room-type-select>
        <board-select
          required
          multiple
          class="md-layout-item md-size-45"
          v-model="filters.board_ids"
          :disabled="filters.room_type_ids.length > 0"
        ></board-select>

        <md-field>
          <label>Online/Offline</label>
          <md-select v-model="filters.channels_online">
            <md-option :value="true">Online</md-option>
            <md-option :value="false">Offline</md-option>
          </md-select>
        </md-field>
      </div>

      <div class="md-layout">
        <date-window v-model="filters.travel_windows" :apply-limit-days="true">
          <template v-slot:label>TW</template>
        </date-window>
      </div>
    </md-card-content>
    <md-card-actions>
      <md-button @click="$emit('applyFilters', filters)" v-if="requiredFiltersFilled">Generate table</md-button>
    </md-card-actions>
  </md-card>
</template>

<script>
import RoomTypeSelect from '../../../../../components/Inputs/RoomTypeSelect.vue'
import BoardSelect from '../../../../../components/Inputs/BoardSelect.vue'
import DateWindow from '../../../../../components/Pricing/Inputs/DateWindow'

export default {
  name: 'TargetFilters',
  components: {
    RoomTypeSelect,
    BoardSelect,
    DateWindow,
  },
  data() {
    return {
      filters: {
        board_ids: [],
        room_type_ids: [],
        travel_windows: [{ key: new Date().toISOString(), value: new Date().toISOString() }],
        channels_online: null,
      },
    }
  },
  computed: {
    requiredFiltersFilled() {
      return (this.filters.board_ids.length || this.filters.room_type_ids.length) && this.filters.channels_online != null
    },
  },
  watch: {
    'filters.board_ids': function() {
      this.$emit('change')
    },
    'filters.room_type_ids': function() {
      this.$emit('change')
    },
  },
}
</script>
